export enum ClientType {
  PATIENT_APP = 'patient-app',
  PATIENT_WEB = 'patient-web',
  HCP_WEB = 'hcp-web',
}
